// A reindeer, modelled facing +X: a grey-brown body on slim legs, a thick neck
// and large branching antlers. Ported 1:1 from age-of-mcp's classic reindeer.ts,
// restoring its leg loop, body composition and the branching-antler side loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.035], [0.07, -0.035], [-0.07, 0.035], [-0.07, -0.035]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.155, 4),
      color: "#6b5f50", position: [x!, 0.0775, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.058, 0), color: "#8a7c68",
      position: [0, 0.155, 0], scale: [1.7, 1, 0.9] },               // body
    { geometry: new THREE.CylinderGeometry(0.02, 0.028, 0.09, 5), color: "#8a7c68",
      position: [0.095, 0.19, 0], rotation: [0, 0, -0.7] },          // neck
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#9a8c76",
      position: [0.14, 0.225, 0] },                                  // head
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#3a342c",
      position: [0.165, 0.218, 0] },                                 // muzzle
  );
  // Branching antlers — a main beam each side with two tines.
  for (const side of [1, -1]) {
    parts.push(
      { geometry: new THREE.CylinderGeometry(0.004, 0.004, 0.07, 4), color: "#caa878",
        position: [0.13, 0.27, side * 0.018], rotation: [0, 0, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.003, 0.003, 0.035, 4), color: "#caa878",
        position: [0.155, 0.3, side * 0.024], rotation: [0, 0, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.003, 0.003, 0.03, 4), color: "#caa878",
        position: [0.105, 0.3, side * 0.024], rotation: [0, 0, 0.8] },
    );
  }
  return parts;
}

export const reindeer = defineModel({
  id: "reindeer",
  batchId: "standard",
  name: "Reindeer",
  tags: ["creature","reindeer","low-poly","age-of-mcp","classic"],
  summary: "Low-poly reindeer.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.15,
  parts: () => partsFor(),
  animations: [],
});
